import { useNavigate } from "react-router-dom";
import { Settings, LogOut } from "lucide-react";
import {
	CommandDialog,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
	CommandSeparator,
} from "./ui/command";
import { useLanguage } from "../contexts/LanguageContext";

/**
 * ⌘K / Ctrl+K palette: jump to any section without hunting through the menu.
 * `groups` is the same structure the sidebar renders, so the palette always
 * stays in sync with the navigation.
 */
export function CommandPalette({ open, onOpenChange, groups, onLogout }) {
	const navigate = useNavigate();
	const { t } = useLanguage();

	const run = (action) => {
		onOpenChange(false);
		// Let the dialog close before navigating, so the route transition does
		// not fight the exit animation.
		requestAnimationFrame(action);
	};

	return (
		<CommandDialog open={open} onOpenChange={onOpenChange}>
			<CommandInput placeholder={t("navSearchPlaceholder")} />
			<CommandList>
				<CommandEmpty>{t("navSearchEmpty")}</CommandEmpty>
				{groups.map((group) => (
					<CommandGroup key={group.id} heading={group.label}>
						{group.links.map((link) => {
							const Icon = link.icon;
							return (
								<CommandItem
									key={link.href}
									value={`${group.label} ${link.label}`}
									onSelect={() => run(() => navigate(link.href))}
									className="cursor-pointer"
								>
									<Icon className="mr-2 h-4 w-4" />
									<span>{link.label}</span>
									{link.badge > 0 && (
										<span className="ml-auto h-5 min-w-[20px] px-1 flex items-center justify-center rounded-full bg-blaze text-white text-[11px]">
											{link.badge > 99 ? "99+" : link.badge}
										</span>
									)}
								</CommandItem>
							);
						})}
					</CommandGroup>
				))}
				<CommandSeparator />
				<CommandGroup heading={t("navSearchActions")}>
					<CommandItem
						value={t("settings")}
						onSelect={() => run(() => navigate("/settings"))}
						className="cursor-pointer"
					>
						<Settings className="mr-2 h-4 w-4" />
						<span>{t("settings")}</span>
					</CommandItem>
					<CommandItem
						value={t("logout")}
						onSelect={() => run(onLogout)}
						className="cursor-pointer text-blaze"
					>
						<LogOut className="mr-2 h-4 w-4" />
						<span>{t("logout")}</span>
					</CommandItem>
				</CommandGroup>
			</CommandList>
		</CommandDialog>
	);
}
